<template>
  <div>
    <div class='wrapHeader'>
      <el-form :inline="true" :model="selectLog" class="demo-form-inline">
        <el-form-item label="仓房选择">
          <el-select v-model="selectLog.wareId" clearable placeholder="仓房选择" @change='conditionChange'>
            <el-option :label="item.wareName" :value="item.wareId" v-for='item in wareList' :key='item.wareId'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="完成状态">
          <el-select v-model="selectLog.isComplete" clearable placeholder="完成状态" @change='conditionChange'>
            <el-option :label="item.statusName" :value="item.statusCode" v-for='item in statusList' :key='item.statusCode'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间">
          <el-date-picker
            v-model="selectLog.beginTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            default-time='00:00:00'
            :picker-options="startPickerOpts"
            @change='conditionChange'
            placeholder="开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            v-model="selectLog.endTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            default-time='23:59:59'
            :picker-options="endPickerOpts"
            @change='conditionChange'
            placeholder="结束时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class='setBgImg' :style='`height:${height}px`'>
      <div class='publicWrap'>
        <div class='showView' :style="`height:${height-20}px;width:${width-30}px`">
          <el-button type="danger" class='commonBtn delMoreHistory' @click="delMoreLog">多条删除<i class="el-icon-delete el-icon--right"></i></el-button>
          <div class='setMacView' :style="`height:${height-100}px;width:${width-60}px`">
            <el-table
              :data="tableData"
              style="width: 100%"
              :header-cell-style='{"background":"rgba(48,56,255,0.03)"}'
              :max-height="height-149"
              border
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="55" align='center'></el-table-column>
              <el-table-column type="index" width="60" align='center' label="序号" :index="indexMethod"></el-table-column>
              <el-table-column prop="wareName" label="仓房名称" align="center" min-width='10%' sortable></el-table-column>
              <el-table-column
                prop="tempMax"
                label="最高粮温"
                align="center"
                min-width='10%'
              >
              </el-table-column>
              <el-table-column
                prop="tempMin"
                label="最低粮温"
                align="center"
                min-width='10%'
              >
              </el-table-column>
              <el-table-column
                prop="tempAve"
                label="平均粮温"
                align="center"
                min-width='10%'
              >
              </el-table-column>
              <el-table-column
                prop="tempIn"
                label="仓内温"
                align="center"
                min-width='10%'
              >
              </el-table-column>
              <el-table-column
                prop="tempOut"
                label="仓外温"
                align="center"
                min-width='10%'
              >
              </el-table-column>
              <el-table-column
                prop="humidityIn"
                label="仓内湿"
                align="center"
                min-width='10%'
              >
              </el-table-column>
              <el-table-column
                prop="humidityOut"
                label="仓外湿"
                align="center"
                min-width='10%'
              >
              </el-table-column>
              <el-table-column
                prop="updateTime"
                label="采集时间"
                align="center"
                min-width='20%'
              >
              </el-table-column>
              <el-table-column
                prop="isComplete"
                label="完成状态"
                align="center"
                min-width='10%'
                sortable
              >
                <template slot-scope="scope">
                  <span :class='scope.row.isComplete==1?"oilonLine":"oiloffLine"'>{{scope.row.isComplete==1?"采集成功":"采集失败"}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="15%" align='center'>
                <template slot-scope="scope">
                  <el-button @click.native.prevent="handleDelete(tableData[scope.$index].grainId)" type="text" size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              layout="total,prev, pager, next"
              :total="total"
              :hide-on-single-page='true'
              :pageSize='selectLog.pageSize' 
              :current-page='selectLog.pageNum'
              @current-change='getOtherLog'
              class='setPosition'>
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../axios.js'
export default {
  props:{
    width:Number,
    height:Number
  },
  data(){
    return{
      selectLog:{
        pageNum:1,
        pageSize:14,
        orderByColumn:'createTime',
        isAsc:'desc',
        wareId:'',
        beginTime:'',
        endTime:''
      },
      wareList:[],
      tableData:[],
      grainIds:[],
      statusList:[{
        statusCode:'0',
        statusName:'采集失败'
      },{
        statusCode:'1',
        statusName:'采集成功'
      }],
      total:0,
      startPickerOpts:{
        disabledDate:(t)=>{
          return this.selectLog.endTime?t.getTime()>new Date(this.selectLog.endTime).getTime():false
        }
      },
      endPickerOpts:{
        disabledDate:(t)=>{
          return this.selectLog.beginTime?t.getTime()<new Date(this.selectLog.beginTime).getTime():false
        }
      }
    }

  },
  created(){
    this.getWareList()
    this.getselectInfo()
  },
  methods:{
    getWareList(){
      axios.get('/system/house/getHouseSelect').then(res=>{
        if(res.code==200){
          this.wareList=res.data
        }
      })
    },
    getselectInfo(){
      axios.get('/system/grain/list',{params:this.selectLog}).then(res=>{
        if(res.code==200){
          this.tableData=res.rows;
          this.total=res.total
        }
      })
    },
    conditionChange(){
      this.selectLog.pageNum=1
      this.getselectInfo()
    },
    getOtherLog(val){
      this.selectLog.pageNum=val
      this.getselectInfo()
    },
    handleDelete(grainId){
      this.grainIds=[grainId]
      this.delLog()
    },
    delMoreLog(){
      if(this.grainIds==[]){
        this.$message({
          message:'请勾选要删除的数据',
          type:'success',
          duration:1000
        })
      }else{
        this.delLog()
      }
    },
    delLog(){
      this.$confirm('此操作将永久删除所选日志, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.delete(`/system/grain/${this.grainIds}`).then(res=>{
          this.grainIds=[]
          if(res.code==200){
            this.getselectInfo()
            this.$message({
              type: 'success',
              message: '删除成功!',
              duration:1000
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          duration:1000
        });          
      });
    },
    handleSelectionChange(val){
      let grainIds=[]
      val.forEach(item=>{
        grainIds.push(item.grainId)
      })
      this.grainIds=grainIds
    },
    indexMethod(index){
      return (this.selectLog.pageNum-1)*this.selectLog.pageSize+index+1
    }
  }
}
</script>

<style>
.oilonLine{color: #3BD14A}
.oiloffLine{color: #AFAFAF}
.delMoreHistory{left: 15px;}
</style>
